import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, catchError, map, of, switchMap } from 'rxjs';

import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class SharedStoreEffects {
  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
  ) {}
}
